import { LotSearch, GetLotResult, GetStampingByLotNoResult, StampingSearch, ToolingSearch, GetToolingNoByPlatingResult, MFGDateSearch, GetMFGDateByLotNoResult, GetPlatingByStampingResult, PlatingSearch } from './../model/item.model';
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { ItemCategory } from '../model/itemcategory.model';
import { User } from '../model/user.model';

const API_URL = environment.apiUrl;

const httpOptions = {
    headers: new HttpHeaders(
        {
            'Content-Type': 'application/json',
        }
    )
};

@Injectable()
export class ItemCategoryService {
    private Url = '';  // URL to web api
    currentUser: User;

    constructor(
        private http: HttpClient) {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.Url = API_URL + '/' + (this.currentUser.CompanyID ? this.currentUser.CompanyID.toString() : "1") + '/ItemCategory';
        // console.log(this.currentUser);
    }

    getItemCategory(): Observable<ItemCategory[]> {
        return this.http.get<ItemCategory[]>(this.Url, httpOptions)
            .pipe(
                tap(response => {
                    // this.log(`fetched `)
                })
            );
    }
    addItemCategory(item: ItemCategory): Observable<any> {

        return this.http.post<ItemCategory>(this.Url, item, httpOptions).pipe(
            tap((res: any) => this.log(`added  w/ id=${res.id}`)),
            catchError(this.handleError<any>('Add'))
        );
    }
    updateItemCategory(item: ItemCategory): Observable<any> {
        console.log('updateItem : ', item);
        const url = `${this.Url}/`;
        console.log(url);

        return this.http.put(url, item, httpOptions).pipe(
            tap(_ => this.log),
            catchError(this.handleError<any>('updated'))
        );
    }
    deleteItemCategory(item: ItemCategory): Observable<any> {
        console.log('updateItem : ', item);
        const url = `${this.Url}/`;
        console.log(url);

        return this.http.put(url, item, httpOptions).pipe(
            tap(_ => this.log),
            catchError(this.handleError<any>('updated'))
        );
    }





    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    /** Log a ScgCompanyService message with the MessageService */
    private log(message: string) {
        console.log(message);
        // this.messageService.add('ScgCompanyService: ' + message);
    }


}


// WEBPACK FOOTER //
// ./src/app/services/itemcategory.service.ts